import store from '../store';

export const isExpired = () => {
  // ログインしていなかったらチェックをしない
  if (!store.state.user.accessToken) return false

  const currentDate = new Date().toLocaleString({ timeZone: 'Asia/Tokyo' })
  const diff = (new Date(currentDate) - new Date(store.state.user.lastOperatedDate)) / 1000
  return diff >= 1 * 60 * 60
}


export const logOut = async() => {
  store.commit('user/logout')
  store.commit('user/setRole', { role: null })
  store.commit('user/setLastOperatedDate', { lastOperatedDate: null })
}
